export default {
  DEFAULT_STATE: "quiz-app/current-quiz/default-state",
};
